import { render } from "./UserChats.vue?vue&type=template&id=64392d4a&scoped=true"
import script from "./UserChats.vue?vue&type=script&lang=js"
export * from "./UserChats.vue?vue&type=script&lang=js"

import "./UserChats.vue?vue&type=style&index=0&id=64392d4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64392d4a"]])

export default __exports__